import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/light/trash-alt.svg'
import BaseIcon from '../../BaseIcon'

const TrashAlt = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 448 512" />
}

TrashAlt.propTypes = {
	className: PropTypes.string,
}

export default TrashAlt
